/* eslint-disable @typescript-eslint/no-var-requires */
import Raven from 'raven-js';
import { initializeHublessAppAuth } from 'quartz-auth/hubless/initialize';
import { getAuth, getGates } from 'quartz-auth/hubless/service';
import { set } from 'quartz/globalState/api';
import { HUBLESS_APP_AUTH_RESULT } from 'quartz-auth/hubless/globalState';
import { assertInternalAuthEmail } from 'quartz-auth/internal/internalAuth';
import { getQuartzConfig } from 'quartz-config/evaluable';
import { invariant } from 'quartz/invariant';
import { gate } from 'hub-http/gates';
import { getHstc } from 'usage-tracker-core/common/defaultTrackers';
import { mark } from '../perf';
const quartzConfig = getQuartzConfig();
/* invariant(quartzConfig.type === 'application' && quartzConfig.auth === 'hubless') */
;
const isPublicI18n = !!(quartzConfig.i18n && quartzConfig.i18n.languageSupport === 'public');
const registerFn = isPublicI18n ? require('I18n/init/register/sync/registerAllPublicData').default : require('I18n/init/register/sync/registerAllData').default;
export const adapter = {
  async initialize(queryParams) {
    /* invariant(quartzConfig.type === 'application' && quartzConfig.auth === 'hubless') */
    ;
    const authResult = await initializeHublessAppAuth({
      queryParams
    });
    if ( /* quartzConfig.internal */false) {
      assertInternalAuthEmail(authResult.auth.user.emails);
    }
    mark('quartz.authFinished');
    return adapter.initializeWithState();
  },
  setGlobalState(authResult) {
    set(HUBLESS_APP_AUTH_RESULT, authResult);
  },
  getUserId() {
    return getAuth().user.id;
  },
  initializeWithState() {
    const {
      user
    } = getAuth();
    Raven.setUserContext({
      id: `${user.id}`,
      email: Array.isArray(user.emails) ? user.emails[0] : undefined,
      // @ts-expect-error `locale` is not standard but will work
      locale: user.locale
    });
    return {
      userId: user.id,
      localeInfoFallback: !isPublicI18n ? {
        locale: user.locale,
        langEnabled: user.languageEnabled
      } : undefined,
      gates: new Set()
    };
  },
  getI18nConfig() {
    return {
      isPublicI18n,
      registerFn
    };
  },
  getTrackingProperties() {
    var _user$emails$;
    const {
      user
    } = getAuth();
    const email = Array.isArray(user.emails) ? (_user$emails$ = user.emails[0]) !== null && _user$emails$ !== void 0 ? _user$emails$ : null : null;
    return {
      email,
      hstc: getHstc(),
      hubId: null
    };
  },
  shouldUseLegacyRoot() {
    /* invariant(quartzConfig.type === 'application' && quartzConfig.auth === 'hubless') */
    ;
    const {
      createRootApi = true
    } = quartzConfig;
    if (!createRootApi || typeof createRootApi === 'boolean' || createRootApi === 'tests-only') {
      return !createRootApi || createRootApi === 'tests-only';
    }
    return !getGates().has(
    // eslint-disable-next-line hubspot-dev/no-bare-gate-strings
    createRootApi.isV2Gate ? createRootApi.gate : gate(createRootApi.gate));
  }
};